import React, { useEffect, useState } from 'react';
import '../../App.css';

function CommentSection({ postId }) {
  const [comments, setComments] = useState([]);
  const [author, setAuthor] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [user, setUser] = useState(null);
  const [commentsLoading, setCommentsLoading] = useState(true);
  const [replyingTo, setReplyingTo] = useState(null);
const [replyContent, setReplyContent] = useState('');
const [editingComment, setEditingComment] = useState(null);
const [editContent, setEditContent] = useState('');
// Add delete state
const [deletingComment, setDeletingComment] = useState(null);


  const apiUrl = process.env.REACT_APP_API_URL ;

  useEffect(() => {
    fetchComments();
    getCurrentUser();
  }, [postId]);
    // Get current user from localStorage or session
    const getCurrentUser = () => {
      try {
        const userData = localStorage.getItem('user');
        const authToken = localStorage.getItem('authToken');
        
        if (userData && authToken) {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
          setAuthor(parsedUser.email || ''); // Pre-fill with user's email
        }
      } catch (error) {
        console.error('Error getting user data:', error);
      }
    };
    const fetchComments = async () => {
      setCommentsLoading(true);
      try {
        const response = await fetch(`${apiUrl}/post-comments/${postId}`);
        if (response.ok) {
          const data = await response.json();
          setComments(data);
        } else {
          console.error('Failed to fetch comments');
          setError('Failed to load comments');
        }
      } catch (error) {
        console.error('Error fetching comments:', error);
        setError('Network error while loading comments');
      } finally {
        setCommentsLoading(false);
      }
    };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!author.trim() || !content.trim()) {
      setError('Please fill in all fields');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');
    
    try {
      const response = await fetch(`${apiUrl}/blog/comments`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          postId: parseInt(postId), 
          author: author.trim(), 
          content: content.trim(),
          userId: user.id // Include userId from session
        })
      });

      if (response.ok) {
        const newComment = await response.json();
        setComments([newComment, ...comments]);
        setAuthor(user.email || '');
        setContent('');
        setError('');
        setSuccess('Comment posted successfully!');
        
        // Clear success message after 3 seconds
        setTimeout(() => setSuccess(''), 3000);
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Failed to submit comment');
      }
    } catch (error) {
      console.error('Error submitting comment:', error);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };
    // Helper function to get user initials for avatar
    const getUserInitials = (email) => {
      if (!email) return 'U';
      const parts = email.split('@')[0].split('.');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return email[0].toUpperCase();
    };
  
    // Helper function to format date
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const now = new Date();
      const diffTime = Math.abs(now - date);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      
      if (diffDays === 1) return 'Today';
      if (diffDays === 2) return 'Yesterday';
      if (diffDays <= 7) return `${diffDays - 1} days ago`;
      
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    };
  
    // Show login prompt if user is not logged in
    if (!user) {
      return (
        <div className="comment-section">
          <div className="comment-box">
            <div className="login-prompt">
              <div className="login-prompt-icon">🔒</div>
              <div className="login-prompt-text">Join the conversation!</div>
              <p>Please log in to view and post comments.</p>
              <a href="/">Sign In / Sign Up</a>
            </div>
          </div>
        </div>
      );
    }

    const handleReply = async (parentCommentId) => {
      if (!replyContent.trim()) {
        setError('Please enter a reply');
        return;
      }
    
      setLoading(true);
      try {
        const authToken = localStorage.getItem('authToken');
        
        const response = await fetch(`${apiUrl}/blog/comments`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
          },
          body: JSON.stringify({ 
            postId: parseInt(postId), 
            author: user.email, 
            content: replyContent.trim(),
            userId: user.id,
            parentCommentId: parentCommentId
          })
        });
    
        if (response.ok) {
          // Refresh all comments to get proper organization
          await fetchComments();
          setReplyContent('');
          setReplyingTo(null);
          setSuccess('Reply posted successfully!');
          setTimeout(() => setSuccess(''), 3000);
        } else {
          const errorData = await response.json();
          setError(errorData.error || 'Failed to post reply');
        }
      } catch (error) {
        setError('Network error. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    
   // Update handleLike function
const handleLike = async (commentId) => {
  try {
    const authToken = localStorage.getItem('authToken');
    
    const response = await fetch(`${apiUrl}/blog/comments/${commentId}/like`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify({ userId: user.id })
    });

    if (response.ok) {
      const updatedComment = await response.json();
      setComments(comments.map(comment => 
        comment.id === commentId ? updatedComment : comment
      ));
    }
  } catch (error) {
    console.error('Error liking comment:', error);
  }
};

// Add delete function
const handleDelete = async (commentId) => {
  if (!window.confirm('Are you sure you want to delete this comment?')) {
    return;
  }

  setDeletingComment(commentId);
  try {
    const authToken = localStorage.getItem('authToken');
    
    const response = await fetch(`${apiUrl}/blog/comments/${commentId}`, {
      method: 'DELETE',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify({ userId: user.id })
    });

    if (response.ok) {
      setComments(comments.filter(comment => 
        comment.id !== commentId && comment.parentCommentId !== commentId
      ));
      setSuccess('Comment deleted successfully!');
      setTimeout(() => setSuccess(''), 3000);
    } else {
      const errorData = await response.json();
      setError(errorData.error || 'Failed to delete comment');
    }
  } catch (error) {
    setError('Network error. Please try again.');
  } finally {
    setDeletingComment(null);
  }
};
    const handleEdit = async (commentId) => {
      if (!editContent.trim()) {
        setError('Please enter content');
        return;
      }
    
      setLoading(true);
      try {
        const authToken = localStorage.getItem('authToken');
        
        const response = await fetch(`${apiUrl}/blog/comments/${commentId}`, {
          method: 'PUT',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
          },
          body: JSON.stringify({ 
            content: editContent.trim(),
            userId: user.id
          })
        });
    
        if (response.ok) {
          const updatedComment = await response.json();
          setComments(comments.map(comment => 
            comment.id === commentId ? updatedComment : comment
          ));
          setEditingComment(null);
          setEditContent('');
          setSuccess('Comment updated successfully!');
          setTimeout(() => setSuccess(''), 3000);
        } else {
          const errorData = await response.json();
          setError(errorData.error || 'Failed to update comment');
        }
      } catch (error) {
        setError('Network error. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    
    const startEdit = (comment) => {
      setEditingComment(comment.id);
      setEditContent(comment.content);
    };
    
    const cancelEdit = () => {
      setEditingComment(null);
      setEditContent('');
    };
    
    const startReply = (commentId) => {
      setReplyingTo(commentId);
      setReplyContent('');
    };
    
    const cancelReply = () => {
      setReplyingTo(null);
      setReplyContent('');
    };
    // Add this helper function before the return statement
const organizeComments = (comments) => {
  const parentComments = comments.filter(comment => !comment.parentCommentId);
  const replies = comments.filter(comment => comment.parentCommentId);
  
  return parentComments.map(parent => ({
    ...parent,
    replies: replies.filter(reply => reply.parentCommentId === parent.id)
      .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)) // Sort replies chronologically
  })).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sort parent comments by newest first
};
    return (
      <div className="comment-section">
        <div className="comment-box">
          <h3>Comments ({comments.length})</h3>
  
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}
  
          <form onSubmit={handleSubmit} className="comment-form">
            <input
              type="email"
              value={author}
              onChange={e => setAuthor(e.target.value)}
              placeholder="Your Email"
              required
              disabled={loading}
              readOnly
            />
            <textarea
              value={content}
              onChange={e => setContent(e.target.value)}
              placeholder="Share your thoughts..."
              required
              disabled={loading}
            />
            <button type="submit" disabled={loading}>
              {loading ? 'Posting...' : 'Post Comment'}
            </button>
          </form>
  
          {/* Comments Loading State */}
          {commentsLoading ? (
            <div className="comments-loading">
              <div className="comments-loading-spinner"></div>
              <p>Loading comments...</p>
            </div>
          ) : (
            <>
              {/* Comments List */}
              {comments.length > 0 ? (
  <ul className="comments-list">
    {organizeComments(comments).map((comment, index) => (
      <li key={comment.id} className={`comment-item ${index === 0 && success ? 'new-comment' : ''}`}>
        {/* Parent Comment */}
        <div className="comment-header">
          <div className="comment-author">
            <div className="comment-avatar">
              {getUserInitials(comment.author)}
            </div>
            <div className="comment-author-info">
              <div className="comment-author-name">
                {comment.User?.name || comment.author.split('@')[0]}
              </div>
              <div className="comment-author-email">
                {comment.author}
              </div>
            </div>
          </div>
          <div className="comment-meta">
            <span className="comment-date">
              {formatDate(comment.createdAt)}
            </span>
            {comment.userId === user.id && (
              <span className="comment-badge">Your Comment</span>
            )}
          </div>
        </div>
        
        {editingComment === comment.id ? (
          <div className="edit-form">
            <textarea
              value={editContent}
              onChange={e => setEditContent(e.target.value)}
              className="edit-textarea"
              disabled={loading}
            />
            <div className="edit-actions">
              <button 
                onClick={() => handleEdit(comment.id)}
                disabled={loading}
                className="save-btn"
              >
                {loading ? 'Saving...' : 'Save'}
              </button>
              <button 
                onClick={cancelEdit}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <p className="comment-content">{comment.content}</p>
        )}

        <div className="comment-actions">
          <button 
            className={`comment-action-btn ${comment.isLiked ? 'liked' : ''}`}
            onClick={() => handleLike(comment.id)}
          >
            {comment.isLiked ? '❤️' : '👍'} {comment.isLiked ? 'Liked' : 'Like'} {comment.likes > 0 && `(${comment.likes})`}
          </button>
          <button 
            className="comment-action-btn"
            onClick={() => startReply(comment.id)}
          >
            💬 Reply {comment.replies?.length > 0 && `(${comment.replies.length})`}
          </button>
          {comment.userId === user.id && editingComment !== comment.id && (
            <>
              <button 
                className="comment-action-btn"
                onClick={() => startEdit(comment)}
              >
                ✏️ Edit
              </button>
              <button 
                className="comment-action-btn delete-btn"
                onClick={() => handleDelete(comment.id)}
                disabled={deletingComment === comment.id}
              >
                {deletingComment === comment.id ? '🔄 Deleting...' : '🗑️ Delete'}
              </button>
            </>
          )}
        </div>

        {replyingTo === comment.id && (
          <div className="reply-form">
            <textarea
              value={replyContent}
              onChange={e => setReplyContent(e.target.value)}
              placeholder="Write your reply..."
              className="reply-textarea"
              disabled={loading}
            />
            <div className="reply-actions">
              <button 
                onClick={() => handleReply(comment.id)}
                disabled={loading}
                className="reply-btn"
              >
                {loading ? 'Posting...' : 'Post Reply'}
              </button>
              <button 
                onClick={cancelReply}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        {/* Replies Section */}
        {comment.replies && comment.replies.length > 0 && (
          <div className="replies-container">
            <div className="replies-header">
              <span className="replies-count">{comment.replies.length} {comment.replies.length === 1 ? 'Reply' : 'Replies'}</span>
            </div>
            <ul className="replies-list">
              {comment.replies.map((reply) => (
                <li key={reply.id} className="reply-item">
                  <div className="comment-header">
                    <div className="comment-author">
                      <div className="comment-avatar reply-avatar">
                        {getUserInitials(reply.author)}
                      </div>
                      <div className="comment-author-info">
                        <div className="comment-author-name">
                          {reply.User?.name || reply.author.split('@')[0]}
                          <span className="reply-indicator">↳ Reply</span>
                        </div>
                        <div className="comment-author-email">
                          {reply.author}
                        </div>
                      </div>
                    </div>
                    <div className="comment-meta">
                      <span className="comment-date">
                        {formatDate(reply.createdAt)}
                      </span>
                      {reply.userId === user.id && (
                        <span className="comment-badge">Your Reply</span>
                      )}
                    </div>
                  </div>
                  
                  {editingComment === reply.id ? (
                    <div className="edit-form">
                      <textarea
                        value={editContent}
                        onChange={e => setEditContent(e.target.value)}
                        className="edit-textarea"
                        disabled={loading}
                      />
                      <div className="edit-actions">
                        <button 
                          onClick={() => handleEdit(reply.id)}
                          disabled={loading}
                          className="save-btn"
                        >
                          {loading ? 'Saving...' : 'Save'}
                        </button>
                        <button 
                          onClick={cancelEdit}
                          className="cancel-btn"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : (
                    <p className="comment-content">{reply.content}</p>
                  )}

                  <div className="comment-actions">
                    <button 
                      className={`comment-action-btn ${reply.isLiked ? 'liked' : ''}`}
                      onClick={() => handleLike(reply.id)}
                    >
                      {reply.isLiked ? '❤️' : '👍'} {reply.isLiked ? 'Liked' : 'Like'} {reply.likes > 0 && `(${reply.likes})`}
                    </button>
                    {reply.userId === user.id && editingComment !== reply.id && (
                      <>
                        <button 
                          className="comment-action-btn"
                          onClick={() => startEdit(reply)}
                        >
                          ✏️ Edit
                        </button>
                        <button 
                          className="comment-action-btn delete-btn"
                          onClick={() => handleDelete(reply.id)}
                          disabled={deletingComment === reply.id}
                        >
                          {deletingComment === reply.id ? '🔄 Deleting...' : '🗑️ Delete'}
                        </button>
                      </>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </li>
    ))}
  </ul>
) : (
  <div className="comments-empty">
    <div className="comments-empty-icon">💬</div>
    <div className="comments-empty-text">No comments yet</div>
    <div className="comments-empty-subtext">Be the first to share your thoughts!</div>
  </div>
)}
            </>
          )}
        </div>
      </div>
    );
  }
  
  export default CommentSection;